import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuditFilter, DashboardAudit, DashboardIssue, DashboardLocationAuditPage, DashboardPage, DashboardSummary, IssueFilter } from '../models/dashboard.models';

@Injectable({ providedIn: 'root' })
export class DashboardApi {
  private readonly http = inject(HttpClient);
  private readonly base = '/api/bhp/api/dashboard';

  summary(dateFrom: string, dateTo: string, location: string, mine: boolean) {
    return this.http.get<DashboardSummary>(`${this.base}/`, {
      params: { date_from: dateFrom, date_to: dateTo, ...this.scope(location, mine) },
    });
  }

  audits(filter: AuditFilter, page: number, location: string, mine: boolean, plannedDate = '') {
    return this.http.get<DashboardPage<DashboardAudit>>(`${this.base}/audits/`, {
      params: { filter, page, page_size: 10, ...this.scope(location, mine), ...(plannedDate ? { planned_date: plannedDate } : {}) },
    });
  }

  issues(filter: IssueFilter, page: number, location: string, mine: boolean) {
    return this.http.get<DashboardPage<DashboardIssue>>(`${this.base}/issues/`, {
      params: { filter, page, page_size: 10, ...this.scope(location, mine) },
    });
  }

  locationAudits(page: number, location: string, mine: boolean) {
    return this.http.get<DashboardLocationAuditPage>(`${this.base}/location-audits/`, {
      params: { page, page_size: 10, ...this.scope(location, mine) },
    });
  }

  private scope(location: string, mine: boolean): Record<string, string | boolean> {
    return location ? { location_id: location, mine } : { mine };
  }
}
